const types = {
  ORDER_ADD_SCHEDULE: "ORDER_ADD_SCHEDULE",
  ORDER_REMOVE_SCHEDULE: "ORDER_REMOVE_SCHEDULE",
  ORDER_SET: "ORDER_SET",
  ORDER_SET_BY_INDEX: "ORDER_SET_BY_INDEX",
  ORDER_CLEAR: "ORDER_CLEAR",
  ORDER_ADD_INVOICE_CODE: "ORDER_ADD_INVOICE_CODE",
  ORDER_SET_CURRENT_USER: "ORDER_SET_CURRENT_USER",

  FETCH_CATEGORY_PAGINATE: "FETCH_CATEGORY_PAGINATE",
  CATEGORY_LIST_RESET: "CATEGORY_LIST_RESET",
  FETCH_LOCATION_PAGINATE: "FETCH_LOCATION_PAGINATE",
  LOCATION_LIST_RESET: "LOCATION_LIST_RESET",

  SET_INVALID_ORDER: "SET_INVALID_ORDER"
};

export default types;
